import React, { Component } from 'react'

export default class AuthPageLog extends Component {
  render() {
    return <div className="auth-page-logo" />
  }
}
